<mat-sidenav-container (backdropClick)="onBackdropClick()">
  <mat-sidenav
    [mode]="sidenavMode()"
    [opened]="sidenavOpened()"
    [style.width]="sidenavWidth">
    <app-loan-list></app-loan-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
